<template>
  <div class="page-wrapper">
    <div class="key-content">
      <van-notice-bar
        v-if="noticeTip"
        wrapable
        :scrollable="false"
        :color="noticeColor"
        :text="noticeTip"
        :background="noticeBgColor"
      />
      <div class="content-wrapper">
        <div class="row-item name-top">
          <div class="title">签约门店</div>
          <div class="name">{{ companyName }}</div>
        </div>
        <div :class="['shot-wrap', isEdit ? 'edit' : '']">
          <div v-if="!isEdit" class="row-item">
            <div class="title">门店摄像头装配情况</div>
            <div class="select-wrapper">
              <div class="select-operate" @click="selectShot(1)">
                <IconFont
                  :name="
                    shotStatus == 1
                      ? 'xuankuang-gouxuan'
                      : 'xuankuang-weixuanzhong'
                  "
                  :color="shotStatus == 1 ? '#15bb5c' : '#CCCCCC'"
                  size="20px"
                ></IconFont>
                <div class="select-text">已安装</div>
              </div>
              <div class="select-operate" @click="selectShot(2)">
                <IconFont
                  :name="
                    shotStatus == 2
                      ? 'xuankuang-gouxuan'
                      : 'xuankuang-weixuanzhong'
                  "
                  :color="shotStatus == 2 ? '#15bb5c' : '#CCCCCC'"
                  size="20px"
                ></IconFont>
                <div class="select-text">未安装</div>
              </div>
            </div>
          </div>
          <div v-if="isEdit && shotStatusText" class="shot-status-text">
            <div class="title">门店摄像头装配情况</div>
            <div class="text">{{ shotStatusText }}</div>
          </div>
          <div v-if="!isEdit" class="tip-wrapper">
            <img
              class="icon-info"
              src="@/images/key_box/icon_information.png"
            />
            <div class="tip">
              为保证您的财产安全，签约前请先为店铺装配摄像头
            </div>
          </div>
        </div>
        <div v-if="!isEdit" class="key-location-wrapper">
          <div class="title">上传钥匙盒安装位置照片</div>
          <div class="desc">
            司机将参考照片进行钥匙盒安装，请确保照片清晰易读
          </div>
          <div class="img-upload-wrapper">
            <img-upload
              ref="imgUpload"
              :pics.sync="pics"
              :oss-data="ossData"
              @previewImg="previewImg"
            ></img-upload>
          </div>
        </div>
        <div v-if="!isEdit" class="remark-wrap">
          <div class="title">备注</div>
          <div class="desc">
            填写钥匙盒配置密码及具体安装位置，方便司机帮您安装设置密码
          </div>
          <div class="remark-content">
            <textarea
              v-model.trim="remark"
              :maxlength="maxlength"
              placeholder="请填写钥匙盒密码（4位数字）及安装位置"
              class="textarea"
              @keyup="inputValue"
              @paste="inputValue"
            ></textarea>
            <span class="limit">{{ remark.length }}/{{ maxlength }}</span>
          </div>
        </div>
        <div class="driver-content">
          <div v-if="isFinish" class="row-item name-top">
            <div class="title">钥匙盒密码</div>
            <div class="right">
              <div class="text">{{ keyWord }}</div>
              <div class="update-btn" @click="updateKey">修改</div>
            </div>
          </div>
          <div v-if="driverImgs.length && isEdit" class="driver-key-location">
            <div class="title">钥匙盒安装位置照片</div>
            <div class="img-wrap">
              <img
                v-for="(pic, index) in driverImgs"
                :key="index"
                :src="pic"
                class="img-pic"
                @error="imgLoadFail"
                @click.stop="previewImg(pic)"
              />
            </div>
          </div>
        </div>
        <div v-if="isEdit && !isFinish && remark" class="remark-wrap edit">
          <div class="title">照片备注</div>
          <div class="remark-content-edit">{{ remark }}</div>
        </div>
      </div>
    </div>

    <div v-if="!isEdit" class="bottom-btn">
      <div class="rule-wrapper">
        <div class="rule-icon" @click="changeSelectRule">
          <IconFont
            :name="
              isSelectRule ? 'xuankuang-gouxuan' : 'xuankuang-weixuanzhong'
            "
            :color="isSelectRule ? '#15BB5C' : '#D9D9D9'"
            size="20px"
          />
          <span class="text-label">我已阅读并同意</span>
        </div>

        <span class="rule" :class="themeColorClass" @click="goAgreement"
          >《密码钥匙盒使用协议》</span
        >
      </div>
      <div class="btn" @click="submitKeyBox">完成钥匙盒签约</div>
    </div>
    <mc-mask :show="isShowMask" :prevent-move="false">
      <div class="mask-wrapper">
        <div class="title">请输入密码</div>
        <div class="input-wrapper">
          <form-input
            :value="keyValue"
            class="key-input"
            placeholder="请输入"
            :maxlength="10"
            :type="'number'"
            @input="getKeyValue"
          ></form-input>
          <div v-show="keyValue" class="close-btn" @click.stop="delKey">
            <img
              src="@/images/market_research/icon_close.png"
              class="close-icon"
            />
          </div>
        </div>

        <div class="btn-wrapper">
          <div class="cancel" @click="cancleKey">取消</div>
          <div class="save" @click="saveKey">保存</div>
        </div>
      </div>
    </mc-mask>
  </div>
</template>

<script>
// 连锁营业执照 其他执照列表 页面
import ImgUpload from './components/imgUpload.vue'
import { API } from '@/api'
import themeMixin from '@/common/mixins/theme'
import { imgLoadFail } from '@/utils/oss_image'
import McMask from '@/common/widgets/mask'
import FormInput from '@/common/widgets/form_input'
import { navBar } from '@/utils/native_interactions/native_bar'
export default {
  components: { ImgUpload, McMask, FormInput },
  mixins: [themeMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = '钥匙盒签约'
      navBar.setTitle({
        text: title
      })
      document.title = title
      vm.signTime = vm.$route.query.signTime || ''

      // 编辑状态 有id
      vm.isEdit = !!vm.signTime
      vm.init(vm.signTime)
    })
  },
  data() {
    return {
      ossData: {},
      pics: [],
      shotStatus: 0,
      hevueImgPreview: null,
      remark: '',
      maxlength: 100,
      isSelectRule: false,
      noticeTip: '',
      noticeColor: '', // #FF9600 // #00A64B
      noticeBgColor: '', // #ff960026;  #00a64b26;
      driverImgs: [],
      isShowMask: false,
      keyValue: '',
      keyWord: '',
      isEdit: false,
      isFinish: false,
      shotStatusText: '',
      companyName: '',
      companyPhone: ''
    }
  },
  computed: {},

  methods: {
    imgLoadFail,
    selectShot(status) {
      this.shotStatus = status
    },
    async init(signTime) {
      if (this.hevueImgPreview) {
        this.hevueImgPreview.close()
      }
      if (signTime) {
        try {
          const res = await API.account.configGetByKey({
            key: 'keyboxDetail'
          })
          this.companyName = res?.companyName
          const hasStoreCamera = res?.hasStoreCamera
          const shotStatusTextMap = {
            1: '已安装',
            0: '未安装'
          }
          this.shotStatusText = shotStatusTextMap[hasStoreCamera]
          this.driverImgs = res?.keyBoxLocPics || []
          this.noticeTip = res?.statusDesc || ''
          this.isFinish = Number(res?.status) === 1
          this.remark = res?.picRemark || ''
          this.noticeColor = this.isFinish ? '#00A64B' : '#FF9600'
          this.noticeBgColor = this.isFinish ? '#00a64b26' : '#ff960026'
          this.keyWord = res?.keyBoxPasswords || ''
        } catch (error) {
          this.$catch(error)
        }
      } else {
        const [ossInfo, companyInfo, agreementInfo] = await Promise.all([
          API.newReqGood.getOssKey({
            source_key: 'mall-entrance'
          }),
          API.memberIntegral.getCompanyInfo(),
          API.account.configGetByKey({
            key: 'keyboxAgreement'
          })
        ])
        this.companyName = companyInfo?.company_name
        this.companyPhone = companyInfo?.phone
        this.ossData = ossInfo
        this.agreementUrl = agreementInfo
      }
    },
    async submitKeyBox() {
      if (!this.shotStatus) {
        return this.$toast('请填写门店摄像头安装情况')
      }
      if (!this.pics.length) {
        return this.$toast('请上传钥匙盒安装位置图片')
      }
      if (!this.isSelectRule) {
        return this.$toast('请阅读并同意密码钥匙盒使用协议')
      }

      if (!this.remark) {
        return this.$toast('请填写备注')
      }

      this.$track(this.$trackMap.keyBox.signClick, {
        sapp_passport_phone: this.companyPhone + ''
      })

      const hasStoreCamera = this.shotStatus === 1 ? 1 : 0
      try {
        const params = {
          key: 'keybox',
          type: 1,
          hasStoreCamera,
          keyBoxLocPics: this.pics,
          picRemark: this.remark
        }
        await API.account.configOperate(params)
        this.$router.back()
      } catch (error) {
        this.$catch(error)
      }
    },
    changeSelectRule() {
      this.isSelectRule = !this.isSelectRule
    },
    goAgreement() {
      if (this.agreementUrl) {
        this.$autoRedirect(this.agreementUrl)
      }
    },
    previewImg(img) {
      this.hevueImgPreview = this.$hevueImgPreview(img)
    },
    inputValue(e) {
      if (this.remark.length > this.maxlength) {
        this.$toast({
          message: `字数限制${this.maxlength}字以内`,
          position: 'top'
        })
      }
    },
    updateKey() {
      this.$track(this.$trackMap.keyBox.passwordClick)
      this.isShowMask = true
    },
    getKeyValue(value) {
      this.keyValue = value
    },
    cancleKey() {
      this.$track(this.$trackMap.keyBox.passwordCancel)
      this.isShowMask = false
    },
    async saveKey() {
      this.$track(this.$trackMap.keyBox.passwordSubmit)
      try {
        const params = {
          key: 'keybox',
          type: 2,
          id: this.id, // id必传
          words: this.keyValue // 密码
        }
        await API.account.configOperate(params)
        this.keyWord = this.keyValue
        this.isShowMask = false
      } catch (error) {
        this.$catch(error)
        this.keyValue = ''
      }
    },
    delKey() {
      this.keyValue = ''
    },
    validateValue(value) {
      const numberValue = Number(value)
      if (!numberValue) {
        this.$toast({
          message: '请输入密码',
          position: 'bottom'
        })
        return false
      } else if (value.length > 6) {
        this.$toast({
          message: '输入密码不超过6位',
          position: 'bottom'
        })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  background-color: #fff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .key-content {
    flex: auto;
    height: 0;
    overflow: auto;
  }
  .row-item {
    height: 44px;
    @include flex-row-between;
    @include text(14px, #262626);
    &.name-top {
      border-bottom: 1px solid #f5f5f5;
    }
    .title {
      font-weight: bold;
    }
  }
  .content-wrapper {
    padding: 0 16px;
    .shot-status-text {
      height: 44px;
      @include flex-row-between;
      @include text(14px, #262626);
      .title {
        font-weight: bold;
      }
    }
    .row-item {
      .title {
        font-weight: bold;
      }
      .select-wrapper {
        width: 164px;
        // flex: auto;
        @include flex-row-between;
        .select-operate {
          @include flex-row-center;
        }
        .select-text {
          margin-left: 8px;
          @include text(14px, #262626);
        }
      }
    }
    .shot-wrap {
      padding-bottom: 12px;
      border-bottom: 1px solid #f5f5f5;
      &.edit {
        padding-bottom: 0px;
      }
      .tip-wrapper {
        @include flex-row-center-column-normal;
        @include text(12px, #f03100);
        .icon-info {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
    .key-location-wrapper {
      padding: 12px 0;
      border-bottom: 1px solid #f5f5f5;
      .title {
        @include text(14px, #262626, true);
      }
      .desc {
        margin-top: 4px;
        @include text(12px, #8c8c8c);
      }
      .img-upload-wrapper {
        display: flex;
        margin-top: 10px;
      }
    }
    .remark-wrap {
      padding: 10px 0 12px 0;
      &.edit {
        border-top: 1px solid #f5f5f5;
      }
      .title {
        @include text(14px, #262626, true);
      }
      .desc {
        margin-top: 4px;
        @include text(12px, #8c8c8c);
      }
      .remark-content {
        position: relative;
        background: #f5f5f5;
        border-radius: 8px;
        padding: 10px 8px 8px 16px;
        margin-top: 10px;
        .textarea {
          display: block;

          width: 100%;
          height: 100px;
          padding: 0;

          border: 0;

          outline: none;

          box-sizing: border-box;

          font-size: 14px;
          line-height: 20px;
          color: #262626;

          resize: none;
        }
        .limit {
          position: absolute;
          right: 8px;
          bottom: 8px;
          @include text(12px, #8c8c8c);
        }
      }
      .remark-content-edit {
        margin-top: 10px;
        @include text(14px, #595959);
      }
    }
  }
  .driver-content {
    .right {
      @include flex-row-center;
      .update-btn {
        color: #00a64b;
        margin-left: 8px;
      }
    }
    .driver-key-location {
      padding: 12px 0;
      .title {
        @include text(14px, #262626, true);
      }
      .img-wrap {
        margin-top: 10px;
        @include flex-row;
        .img-pic {
          width: 76px;
          height: 76px;
          border-radius: 4px;
          margin-left: 13px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
  }

  .bottom-btn {
    padding: 6px 25px;
    @include iphonex-padding-bottom(6px);
    .rule-wrapper {
      padding-top: 4px;
      padding-bottom: 10px;

      font-size: 14px;
      @include flex-row-center;
      .rule-icon {
        @include flex-row-center;
      }
      .text-label {
        margin-left: 0.08rem;

        color: #8c8c8c;
      }
      .rule {
        color: #15bb5c;
      }
    }
    .btn {
      background-color: #15bb5c;
      height: 44px;
      border-radius: 40px;
      @include flex-row-center;
      @include text(16px, #fff);
    }
  }
}
.mask-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);

  width: 303px;
  background-color: #fff;
  padding: 20px 16px 24px 16px;
  border-radius: 20px;
  box-sizing: border-box;
  .title {
    @include text(16px, #262626, true);
    @include flex-row-center;
  }
  .input-wrapper {
    margin-top: 36px;
    margin-bottom: 36px;
    background-color: #f0f3f7;
    border-radius: 8px;
    padding: 11px 12px;
    height: 44px;
    box-sizing: border-box;
    position: relative;
    .key-input {
      width: 100%;
    }
    .close-btn {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      .close-icon {
        width: 24px;
        height: 24px;
      }
    }
  }
  .btn-wrapper {
    @include flex-row-between;
    .cancel,
    .save {
      width: 129px;
      height: 40px;
      @include flex-row-center;
      border-radius: 20px;
    }
    .cancel {
      background-color: #f0f3f7;
      @include text(16px, #262626);
    }
    .save {
      background-color: #15bb5c;
      @include text(16px, #fff);
    }
  }
}
</style>
